/**
 * Zentrale technische Konstanten von DUELINE.
 *
 * Diese Werte sind KEINE Balancewerte, sondern technische Rahmenbedingungen.
 * Balance- und Gameplaywerte leben in @dueline/game-data.
 */

/** Markenname - verbindlich. Siehe docs/BRANDING.md. */
export const PRODUCT_NAME = 'DUELINE';

/** Primaere Domain des Projekts. Siehe docs/BRANDING.md. */
export const PRODUCT_DOMAIN = 'dueline-game.com';

/** Brandline - Hauptclaim der Marke. */
export const BRANDLINE = 'Hold Your Line. Break Theirs.';

/** Erklaerende Subline. */
export const SUBLINE = 'One Hero. One Line. One Rival.';

/**
 * Einladung in den DUELINE-Discord (Stand 07.10.2026).
 *
 * Steht hier und nicht im Website-Paket, weil ZWEI Seiten sie brauchen:
 * die Homepage ("Join Discord" und das Symbol in der Fusszeile) und seit
 * dem 07.10.2026 das Hauptmenue des Spiels. Zwei Kopien derselben
 * Einladung laufen auseinander, sobald der Link einmal erneuert wird - und
 * dann fuehrt eine von beiden ins Leere.
 *
 * Eine Einladung ist kein Geheimnis: Sie steht auf der oeffentlichen
 * Homepage und darf deshalb im Quelltext stehen (anders als Schluessel
 * oder Passwoerter, die nach .env gehoeren).
 */
export const DISCORD_INVITE_URL = 'https://discord.gg/AqHgC7yUk6';

/**
 * Protokollversion zwischen Client und Server.
 * Wird bei jeder inkompatiblen Aenderung am Netzwerkprotokoll erhoeht.
 * Der Server weist Clients mit abweichender Version ab.
 */
export const PROTOCOL_VERSION = 27;

/**
 * So lange bleibt der Platz nach einem Verbindungsabbruch reserviert
 * (Produktentscheidung vom 24.09.2026).
 *
 * Reicht fuer eine Bildschirmsperre, einen kurzen Anruf oder den Wechsel vom
 * WLAN ins Mobilfunknetz. Kommt niemand zurueck, gewinnt der Verbliebene.
 */
export const RECONNECT_SECONDS = 60;

/**
 * Gesamte Pausenzeit, die ein Spieler im Match zur Verfuegung hat.
 *
 * Bricht die Verbindung ab, haelt das Match an - aber hoechstens so lange, und
 * das ueber das ganze Match zusammengerechnet. Danach laeuft es ohne ihn
 * weiter: Sein Hero bleibt stehen und schlaegt nur noch zurueck.
 *
 * Warum gedeckelt? Sonst koennte man den Gegner mit Flugmodus beliebig oft
 * ausbremsen - genau im falschen Moment.
 *
 * ABWEICHUNG vom Masterprompt (Produktentscheidung vom 06.10.2026):
 * Abschnitt 93 schreibt 30 Sekunden vor, umgesetzt sind 15.
 *
 * Der Masterprompt nennt eine maximale Pausen-DAUER je Abbruch. Umgesetzt
 * ist etwas anderes: ein Konto, das sich ueber das ganze Match
 * zusammenrechnet. Ein Konto von 30 Sekunden waere deutlich mehr als eine
 * einzelne Pause von 30 Sekunden - deshalb der kleinere Wert.
 *
 * Bis zum 06.10.2026 stand die 30 unbenutzt in game-data/match.ts und war
 * die einzige Stelle, an der die Abweichung ueberhaupt zu erkennen war -
 * und zwar nur, wenn man beide Dateien nebeneinanderlegte. Jetzt steht sie
 * hier, wo der geltende Wert steht.
 *
 * ZWEITE ABWEICHUNG, ausdruecklich gewollt (Produktentscheidung vom
 * 06.10.2026): Der Masterprompt kennt zusaetzlich "hoechstens EINE Pause je
 * Spieler und Match". Diese Regel gibt es bei uns NICHT.
 *
 * Es zaehlt allein die Zeit: Wer dreimal fuenf Sekunden weg ist, hat
 * dasselbe verbraucht wie einmal fuenfzehn. Das ist das mildere Verhalten
 * und passt zum Handy, wo eine Verbindung mehrmals kurz wegbricht, ohne
 * dass jemand etwas dafuer kann. Missbrauch verhindert schon die
 * Obergrenze - mehr als das Konto gibt es nicht, egal wie oft man geht.
 *
 * Geprueft wird das im Verhalten, nicht an einer Zahl: "verbraucht das
 * Pausenkonto ueber mehrere Abbrueche zusammen" in MatchRoom.test.ts.
 */
export const DISCONNECT_PAUSE_SECONDS = 15;

/** Serverseitige Simulationstakte pro Sekunde (Masterprompt Abschnitt 30). */
export const SIMULATION_TICK_RATE = 20;

/** Dauer eines Simulationstakts in Millisekunden. */
export const SIMULATION_TICK_MS = 1000 / SIMULATION_TICK_RATE;

/** Name des Colyseus-Raums, in dem ein Match laeuft. */
export const MATCH_ROOM_NAME = 'match';

/** Anzahl Spieler pro Match (1v1). */
export const PLAYERS_PER_MATCH = 2;
